import { render } from "./AppointmentStepDateTime.vue?vue&type=template&id=a53d84f2"
import script from "./AppointmentStepDateTime.vue?vue&type=script&lang=js"
export * from "./AppointmentStepDateTime.vue?vue&type=script&lang=js"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__